// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"ad6f56ef","342":"f15731c9","408":"97f818a4","470":"a794ac39","968":"ec54f73f"}[chunkId] + ".chunk.js";
};